document.addEventListener( 'DOMContentLoaded', () => {
  waitForWistia( () => {
    document.querySelectorAll( '.e-vid--embed' ).forEach( processVideoContainer );
  } );
} );

function waitForWistia( callback ) {
  if ( window._wq ) return callback();
  const interval = setInterval( () => {
    if ( window._wq ) {
      clearInterval( interval );
      callback();
    }
  }, 30 );
}

function processVideoContainer( container ) {
  if ( container.__wistiaInitialized ) return;
  container.__wistiaInitialized = true;

  const playIcon = getPlayIcon( container );
  const posterImage = getPosterImage( container );
  const iframe = getIframe( container );

  if ( !iframe ) return;
  cleanIframeAutoplay( iframe );

  const videoId = extractWistiaId( iframe );
  if ( !videoId ) return;

  initWistiaOverlay( videoId, video => {
    if ( shouldPauseOnReady( playIcon, video ) ) video.pause();
    if ( playIcon ) bindPlayButton( playIcon, video, posterImage, container );
  } );
}

function getPlayIcon( container ) {
  return container.querySelector( '.btn-playback' );
}

function getPosterImage( container ) {
  return container.querySelector( '.e-vid__poster-image' );
}

function getIframe( container ) {
  return container.querySelector( '.wistia_embed' );
}

function cleanIframeAutoplay( iframe ) {
  iframe.removeAttribute( 'autoplay' );
  const src = iframe.getAttribute( 'src' );
  if ( !src ) return;
  const cleanedSrc = src
    .replace( /([&?])autoPlay=1?true?(&|$)/i, ( match, p1, p2 ) => ( p2 === '&' ? p1 : '' ) )
    .replace( /[?&]$/, '' );
  if ( src !== cleanedSrc ) iframe.setAttribute( 'src', cleanedSrc );
}

function extractWistiaId( iframe ) {
  const src = iframe.getAttribute( 'src' ) || '';
  const match = src.match( /embed\/iframe\/([a-zA-Z0-9]+)/ );
  return match ? match[1] : null;
}

function initWistiaOverlay( videoId, onReady ) {
  window._wq.push( { id: videoId, onReady } );
}

function shouldPauseOnReady( playIcon, video ) {
  return playIcon && video.state && video.state() === 'playing';
}

function bindPlayButton( playIcon, video, posterImage, container ) {
  playIcon.addEventListener( 'click', () => {
    const hideOverlay = () => {
      fadeAndHideElement( posterImage, 400 );
      fadeAndHideElement( playIcon, 400, () => container.classList.add( 'played' ) );
      video.unbind( 'firstplay', hideOverlay );
      video.unbind( 'play', hideOverlay );
    };
    video.bind( 'firstplay', hideOverlay );
    video.bind( 'play', hideOverlay );
    video.play();
  }, { once: true } );
}

function fadeAndHideElement( el, duration, callback ) {
  if ( !el ) {
    if ( callback ) callback();
    return;
  }
  el.style.opacity = 0;
  setTimeout( () => {
    el.style.display = 'none';
    if ( callback ) callback();
  }, duration );
}
